import { cache, use } from 'react';
import { isMobileDevice } from './isMobileDevice';

export const loadImage = (name: string): string => {
  return require('@/assets/images/' + name + '.png');
};
const cacheDevice = cache(isMobileDevice);
export const getIsMobile = () => {
  return isMobileDevice();
};

export const getDoubleDimensional = <T>(list: T[], count: number) => {
  const result = [];

  for (let i = 0; i < list?.length; i += count) {
    result.push(list.slice(i, i + count));
  }
  return result;
};

export const getSrc = (name: string) => {
  return `https://cdn-digital.ssv.qq.com/upload/${name}.png`;
};
export const getBr = (text: string) => {
  if (text.includes('|')) {
    return text.split('|').join('<br/>');
  }
  return text.replace(/\n/g, '<br/>');
};

export const isEmail = (str: string) => {
  const reg =
    /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
  return reg.test(str);
};
